import { render, staticRenderFns } from "./CreateCorpoAdminForm.vue?vue&type=template&id=5c0e14ce&scoped=true"
import script from "./CreateCorpoAdminForm.vue?vue&type=script&lang=js"
export * from "./CreateCorpoAdminForm.vue?vue&type=script&lang=js"
import style0 from "./CreateCorpoAdminForm.vue?vue&type=style&index=0&id=5c0e14ce&prod&lang=scss&scoped=true"
import style1 from "./CreateCorpoAdminForm.vue?vue&type=style&index=1&id=5c0e14ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e14ce",
  null
  
)

export default component.exports